import { Button, Text, useMantineTheme } from "@mantine/core";
import { ArrowRight2, Sms } from "iconsax-react";
import { useTranslation } from "react-i18next";

interface IProps {
  nextStep: () => void;
  setType: (value: "email" | "phone") => void;
}

const TypeRecover = ({ nextStep, setType }: IProps) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const selectType = (type: "email" | "phone") => {
    nextStep();
    setType(type);
  };
  return (
    <>
      <Text size={16} fw={400} mx={12} mb={24} maw={602} ta="center">
        {t("autenticacao.acessar_conta.forget_password.step_1.text")}
      </Text>
      <Button
        onClick={() => selectType("email")}
        fullWidth
        rightIcon={<ArrowRight2 size={28} />}
        leftIcon={<Sms size={28} color={theme.colors.primary[0]} />}
        variant="recoverPassword"
        mb={16}
        h={88}
      >
        {t("autenticacao.acessar_conta.forget_password.step_1.button_email")}
      </Button>
      {/* <Button
        onClick={() => {
          setType("phone");
          nextStep();
        }}
        fullWidth
        rightIcon={<ArrowRight2 size={28} />}
        leftIcon={<Mobile size={28} color={theme.colors.primary[0]} />}
        variant="recoverPassword"
        h={88}
        styles={{
          leftIcon: {
            svg: {
              marginLeft: "8px",
            },
          },
        }}
      >
         {t("autenticacao.acessar_conta.forget_password.step_1.button_phone")}
      </Button> */}
    </>
  );
};

export default TypeRecover;
